import api from "@/api";

const state = {
  isMosaicModeActive: true,
  isManualImagesSortingActive: false,
  links: {
    termsAndConditions: "",
    help: "",
  },
  feedbackEmail: null
};

const getters = {
  getFeedbackEmail: (state) => state.feedbackEmail,
};

const mutations = {
  SET_MOSAIC_MODE(state, isActive) {
    state.isMosaicModeActive = isActive;
  },
  SET_MANUAL_IMAGES_SORTING_MODE(state, isActive) {
    state.isManualImagesSortingActive = isActive;
  },
  SET_LINK(state, { name, value }) {
    state.links[name] = value;
  },
  SET_FEEDBACK_EMAIL(state, value) {
    state.feedbackEmail = value;
  }
};

const actions = {
  loadAppSettings({ commit }) {
    api.getSettings()
      .then(({ data: { data } }) => {
        let settings = Object.fromEntries(data.map((setting) => {
          return [setting.name, setting.value]
        }))
        commit('SET_MOSAIC_MODE', !settings.square_thumbnails_display)
        commit('SET_MANUAL_IMAGES_SORTING_MODE', settings.manual_images_sorting)
        commit('SET_LINK', { name: 'termsAndConditions', value: settings.terms_and_conditions })
        commit('SET_LINK', { name: 'help', value: settings.help })
        commit("SET_FEEDBACK_EMAIL", settings.feedback_email);
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}